import { useQuery } from '@tanstack/react-query'
import { zendeskQueries } from '@/features/zendesk-app'
import React from 'react'
import { Option } from '@/components/ui/Autocomplete/Autocomplete.types'

export const useCustomObjectKeyOptions = (): Option[] => {
  const query = useQuery(zendeskQueries.customObjects.list())

  return React.useMemo(
    () =>
      query.data?.custom_objects.map((customObject) => ({
        label: customObject.title,
        value: customObject.key,
      })) ?? [],
    [query.data]
  )
}
